var PromoCodeModel = (function (Model, CheckoutSettings) {
	return Model.extend({
		defaults: {
			code: null
		},

		initialize: function () {
			this.on('change:code', this.apply);
			this.apiRemoveVoucherByKey = this._api.removeVoucherByKey;
			this.updateCheckout = this._updateCheckout;
		},

		apply: function (value) {
			window.app && app.event && app.event.applyVoucher();
			return this._api.addAndApplyVoucherByKey(value, CheckoutSettings.imageSize).done(this._updateCheckout);
		}
	});
})(CheckoutApiModel, CheckoutSettings);